import React from 'react';
import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcon';
import InputCheckbox from '../InputCheckbox';
import InputDate from '../InputDate';
import InputEmail from '../InputEmail';
import InputFile from '../InputFile';
import InputNumber from '../InputNumber';
import InputText from '../InputText';
import Label from '../Label';
import Markdown from '../Markdown';
import Span from '../Span';

const SPAN_DEFAULT = '';
const MARGIN_TOP_CLASS = 'mt-5';

const InputRenderer = ({
  item,
  index,
  errors,
  fieldsValidated,
  fileUploading,
  setFileUploading,
}) => {
  const divClassName = item.label.length > 100 ? 'col-lg-12' : 'col-lg-6';
  const marginClassName = item.type === 'file' ? '' : '';
  const isCheckbox = item.type === 'checkbox';

  return (
    <div
      key={
        isCheckbox
          ? `elements-checkbox-input-${index}`
          : `elements-input-${index}`
      }
      className={isCheckbox ? '' : `${divClassName} ${MARGIN_TOP_CLASS}`}
    >
      {isCheckbox &&
      item.description !== null &&
      item.description !== undefined &&
      item.description !== '' ? (
        <Markdown
          key={`elements-description-markdown-${index}`}
          text={item.description}
        />
      ) : (
        ''
      )}
      <div
        className={
          isCheckbox ? 'form-check mt-4' : `form-group ${marginClassName}`
        }
      >
        <Label
          label={item.label}
          name={item.name}
          errors={errors}
          required={item.required}
        />
        <CustomIcon
          fieldsValidated={fieldsValidated}
          fieldError={errors[item.name]}
          required={item.required}
        />

        {item.type === 'email' ? <InputEmail name={item.name} /> : ''}

        {isCheckbox ? <InputCheckbox name={item.name} /> : ''}

        {item.type === 'file' ? (
          <InputFile
            name={item.name}
            fileExtension={item.fileExtension ? item.fileExtension.data : []}
            fileUploading={fileUploading}
            setFileUploading={setFileUploading}
          />
        ) : (
          ''
        )}

        {item.type === 'number' ? <InputNumber name={item.name} /> : ''}

        {item.type === 'text' ? <InputText name={item.name} /> : ''}

        {item.type === 'date' ? <InputDate name={item.name} /> : ''}

        <Span
          text={
            errors[item.name] ? errors[item.name].message : SPAN_DEFAULT
          }
        />

        {!isCheckbox ? (
          <Markdown
            className="col-xl-12 col-lg-12 mt-3"
            text={item.description}
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

InputRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  errors: PropTypes.object.isRequired,
  fieldsValidated: PropTypes.bool,
  fileUploading: PropTypes.bool,
  setFileUploading: PropTypes.func,
};

export default InputRenderer;
